const CON = {
  TYPE_OPEN_AP: 'OPENAP',
  TYPE_AUDIENCE_MATTERS: 'AM',
  TYPE_USER: 'USER',
  STATUS_NEW: 'NEW',
  STATUS_READ: 'READ',
  STATUS_DELETED: 'DELETED',
  STATUS_ARCHIVED: 'ARCHIVED',
  ALERT_ERROR: 'ERROR',
  ALERT_WARNING: 'WARNING',
  ALERT_SUCCESS: 'SUCCESS',
  ALERT_INFO: 'INFO'
}

const TYPES = {
  ASSIGNED_OPEN_AP: 'openap',
  USER: 'user',
  ATT_ASSIGN: 'att-assign',
  ATT_RESPONSE: 'att-response'
}

export default CON

export {
  TYPES
}



// WEBPACK FOOTER //
// ./src/app/appLogic/notifications/notificationConstants.js